<template>
  <p>
    {{ address.title }} {{ address.firstname }} {{ address.lastname }}<br>
    {{ address.address }}<br>
    {{ address.zip }} {{ address.city }}<br>
    {{ address.country }}
  </p>
</template>
<script>
export default {
  props: ['address']
}
</script>



// WEBPACK FOOTER //
// src/components/users/UserAddress.vue